module.exports = __webpack_public_path__ + "img/7.c1f89296.png";